import { CommonDetails } from 'components/common/details';
import { ErrorBoundary } from 'components/common/error-boundary';
import { JsonViewer } from 'components/common/json/json-viewer';
import { useGSCtrlStore } from 'components/sections/admin-portal/server-controls/game-status/use-game-status-controls-store';
import { format } from 'date-fns-tz';
import { ArrayHelper } from 'lib_ts/classes/array.helper';
import {
  LOCAL_DATETIME_FORMAT_LONG,
  LOCAL_TIMEZONE,
} from 'lib_ts/enums/datetime.enums';
import { useEffect, useMemo } from 'react';

export function GameStatusSummary() {
  const statuses = useGSCtrlStore((s) => s.statuses);
  const statusesUpdated = useGSCtrlStore((s) => s.statusesUpdated);

  useEffect(() => {
    // first load
    useGSCtrlStore.getState().refreshStatuses();

    // automatic refresh every 5s
    const interval = setInterval(() => {
      useGSCtrlStore.getState().refreshStatuses();
    }, 5 * 1000);

    return () => clearInterval(interval);
  }, []);

  const summaryText = useMemo(() => {
    const prefix = 'Statuses from Batrack API';

    if (!statusesUpdated) {
      return prefix;
    }

    const ts = format(statusesUpdated, LOCAL_DATETIME_FORMAT_LONG, {
      timeZone: LOCAL_TIMEZONE,
    });

    return `${prefix} as of ${ts}`;
  }, [statusesUpdated]);

  const statusesDict = useMemo(
    () => ArrayHelper.firstByFn(statuses, (m) => m.team),
    [statuses]
  );

  return (
    <ErrorBoundary identifier="GameStatusSummary">
      <CommonDetails summary={summaryText} gap="0">
        <JsonViewer value={statusesDict} collapse={1} />
      </CommonDetails>
    </ErrorBoundary>
  );
}
